import { Component } from '@angular/core';

@Component({
    selector: 'app-informacion',
    templateUrl: './informacion.component.html',
    styleUrls: ['./informacion.component.scss'],
    standalone: false
})
export class InformacionComponent {
  constructor() {}

}
